import React, { useContext, useEffect }  from 'react';

import NewsContext from '../../context/news-context';
import Loading from '../Loading/index';
import Rating from '../Rating/index';
import fetchNews from '../../utils/fetchNews';
import fetchNewsByLocation from '../../utils/fetchNewsByLocation';
import { NewsSection, Title, Article, ArticleHeading, ArticleCategory, ArticleAbstract } from './style';

const NewsList= ({ category, articles, title, location}) => {
    const { user, news, setNews } = useContext(NewsContext);

    useEffect(() => {
        // Fetch data only if user is logged in 
        if( Object.keys(user).length > 0 ){
            // If Location is given, news will be searched based on location not on category.
            if(location) {
                // If news is fetched before, no need to refetch.
                if(!news[location]){ 
                    const fetchNewsCategoryByLocation = async () => {
                        const categoryNews = await fetchNewsByLocation(location);
                        const correctFormatNews = categoryNews.map(({ headline, abstract , web_url }) => ({ 
                            title: headline.main,
                            abstract,
                            section: location,
                            short_url: web_url
                        }))
                        const filteredNews = correctFormatNews.filter(({ title, abstract}) => (title.length + abstract.length) > 140);
    
                        setNews({
                            ...news,
                            [location]: filteredNews
                        });
                    }
    
                    fetchNewsCategoryByLocation();
                }
            } else {
                // Check if no articles is  given based on filtering or there is no news prefetched on the category 
                if(!articles && !news[category])
                {
                    // Fetch news based on the category
                    const fetchNewsCategory = async () => {
                        const categoryNews = await fetchNews(category);
                        const filteredNews = categoryNews.filter(({ title, abstract}) => (title.length + abstract.length) > 140);
    
                        setNews({
                            ...news,
                            [category]: filteredNews
                        })
                    }
        
                    fetchNewsCategory();
                }
            }    

        }
    }, [articles, category, news, setNews]);

    return (
        <>
            { 
                (articles || (news[location] && news[location].length > 0) || (news[category] && news[category].length > 0)) ?
                    ( 
                        location 
                        ? 
                        <>
                            <Title borderTop="none" >News in {location}</Title>
                            <NewsSection>
                                {
                                    news[location].map(({ title, abstract, section , short_url }) => {
                                        return (
                                            <Article key={short_url}> 
                                                <ArticleHeading><a href={short_url} target="_blank" rel="noreferrer noopener">{ title }</a></ArticleHeading>
                                                <ArticleCategory>{section}</ArticleCategory>
                                                <Rating />
                                                <ArticleAbstract>{abstract}</ArticleAbstract>
                                            </Article>
                                        );
                                    }) 
                                }
                            </NewsSection> 
                        </>
                        : 
                        <>
                        { title && <Title>{title}</Title>}
                            <NewsSection>
                                {   
                                    articles ? 
                                    articles.map(({ title, abstract, section, short_url }) => {
                                        return (
                                            <Article key={short_url}> 
                                                <ArticleHeading><a href={short_url} target="_blank" rel="noreferrer noopener">{ title }</a></ArticleHeading>
                                                <ArticleCategory>{section}</ArticleCategory>
                                                <Rating />
                                                <ArticleAbstract>{abstract}</ArticleAbstract>
                                            </Article>
                                        );
                                    }) :
                                    news[category].map(({ title, abstract, section, short_url }) => {
                                        return (
                                            <Article key={short_url}> 
                                                <ArticleHeading><a href={short_url} target="_blank" rel="noreferrer noopener">{ title }</a></ArticleHeading>
                                                <ArticleCategory>{section}</ArticleCategory>
                                                <Rating />
                                                <ArticleAbstract>{abstract}</ArticleAbstract>
                                            </Article>
                                        );
                                    }) 
                                }
                            </ NewsSection>
                        </>
                    )
                    :
                    <Loading />
            }
        </>
    )
};

export default NewsList;